import CardNavigationRoot, { Props } from './CardNavigation'

export default function CardNavigation(props: Props) {
  return <CardNavigationRoot {...props} />
}

export type { Props } from './CardNavigation'
